import { BusinessInfo } from '@/types/customer';
import { ChildStep } from '@/types/steps';
import { isKeyOf } from '@/utility/isKeyOf';

const warnBadType = (type: string, value: unknown, accessors: readonly string[]): void => {
  console.debug(
    `extract step data failed: value is not a ${type}, value: ${value}, accessors: ${accessors}`,
  );
};

const warnBadAccessor = (obj: any, accessor: readonly string[]): void => {
  console.debug(
    'either provided object is null or accessor is not a key of it',
    accessor,
    'object: ',
    obj,
  );
};

export const extractStepData = (
  businessInfo: BusinessInfo | null,
  step: ChildStep<unknown>,
): Record<string, unknown> => {
  const { accessor } = step;
  const inputData = businessInfo ?? {};

  if (accessor.length === 0) {
    return inputData as Record<string, unknown>;
  }

  const parentKey = accessor[0];
  if (!isKeyOf(inputData, parentKey)) {
    warnBadAccessor(inputData, accessor);
    return {};
  }

  const parentValue = inputData[parentKey];
  if (accessor.length === 1) {
    return isObject(parentValue)
      ? (parentValue as Record<string, unknown>)
      : handleInvalidValue('object', parentValue, accessor);
  }

  const childKey = accessor[1];
  if (!isObject(parentValue) || !isKeyOf(parentValue, childKey)) {
    warnBadAccessor(parentValue, accessor);
    return {};
  }

  const childValue = parentValue[childKey];
  return isObject(childValue)
    ? (childValue as Record<string, unknown>)
    : handleInvalidValue('object', childValue, accessor);
};

const isObject = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object';

const handleInvalidValue = (
  expectedType: string,
  value: unknown,
  accessor: readonly string[],
): Record<string, unknown> => {
  warnBadType(expectedType, value, accessor);
  return {};
};
